/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Demofrau8Inputs */

const en__field_enum_demofrau8 = /** @type {(inputs: _Field_Enum_Demofrau8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ms/Mrs`)
};

const de__field_enum_demofrau8 = /** @type {(inputs: _Field_Enum_Demofrau8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frau`)
};

/**
* | output |
* | --- |
* | "Ms/Mrs" |
*
* @param {_Field_Enum_Demofrau8Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_demofrau8 = /** @type {((inputs?: _Field_Enum_Demofrau8Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Demofrau8Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_demofrau8(inputs)
	return de__field_enum_demofrau8(inputs)
});
export { _field_enum_demofrau8 as "_field_enum_DEMOFRAU" }